<template>
  <div class="mb-2 mb-md-4">
    <button
      class="d-flex align-center text-body-2 text-ui-kit-text-secondary link"
      @click="navigateTo('/')"
    >
      <v-icon
        color="ui-kit-icon-secondary"
        class="mr-2"
        size="24"
      >
        ui-icon-arrow-back
      </v-icon>
      <span class="text-decoration-underline">Вернуться назад</span>
    </button>
  </div>
</template>
